/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typography } from '@mui/material';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';
import * as actionsEquipamento from '../../../store/equipamento/actions';
import * as selectorsEquipamento from '../../../store/equipamento/reducer';

const SisantDialog = ({
  open,
  droneId,
  droneName,
  onClose,
  onSaved,
  findEquipamentoById,
  updateEquipamento,
  selectedEquipamento,
}) => {
  const [codigoSisant, setCodigoSisant] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && droneId) {
      setLoading(true);
      findEquipamentoById(droneId);
    }
    if (!open) {
      setCodigoSisant('');
      setLoading(false);
    }
  }, [open, droneId]);

  useEffect(() => {
    if (selectedEquipamento && selectedEquipamento.id === droneId) {
      setCodigoSisant(selectedEquipamento.codigoSisant || '');
      setLoading(false);
    }
  }, [selectedEquipamento, droneId]);

  const handleConfirm = () => {
    if (!selectedEquipamento) return;
    updateEquipamento(
      { ...selectedEquipamento, codigoSisant: codigoSisant || null },
      (ok) => {
        if (ok) {
          onSaved();
          onClose();
        }
      }
    );
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Registrar Código SISANT"
      confirmMessage="Salvar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
      disabledConfirmButton={loading}
    >
      {droneName && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Drone: <strong>{droneName}</strong>
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        O código SISANT é obrigatório para realizar pedidos de voo. Cadastre o equipamento no sistema SISANT da ANAC e informe o código gerado abaixo.
      </Typography>
      <InputV2
        label="Código SISANT"
        value={loading ? 'Carregando...' : codigoSisant}
        onChange={(e) => setCodigoSisant(e.target.value)}
        disabled={loading}
      />
    </DialogDefaultV2>
  );
};

SisantDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  droneId: PropTypes.string,
  droneName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  findEquipamentoById: PropTypes.func.isRequired,
  updateEquipamento: PropTypes.func.isRequired,
  selectedEquipamento: PropTypes.object,
};

SisantDialog.defaultProps = {
  droneId: null,
  droneName: null,
  selectedEquipamento: null,
};

const mapStateToProps = (state) => ({
  selectedEquipamento: selectorsEquipamento.getSelectedEquipamento(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionsEquipamento }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SisantDialog);
